let selectedCountry = null;

export function ApiUrl() {
  // SSR/SSG-safe: window is undefined during build
  if (typeof window === 'undefined') {
    // Prefer a configurable public URL at build time
    return process.env.GATSBY_API_URL || "https://www.onehistory.io";
  }

  const host = window.location.hostname;
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  return isLocal ? 'http://localhost:8080' : 'https://www.onehistory.io';
}


export function ApiKey() {
	return "v99RdNOKUSTKWgw3ZBl088NCw4A2OYEn";
}

export function Country() {
	return selectedCountry;
}

export function SetCountry(country)
{
	selectedCountry = country;
}

export function DeselectCountry()
{
	selectedCountry = null;	
}
